import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=e345807c&scoped=true&"
import script from "./ProfileForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=e345807c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e345807c",
  null
  
)

export default component.exports